import React from "react";

interface Props {}

const DangeSignSvg = (props: Props) => {
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.9495 13.7485H1.04979C0.78184 13.7485 0.534251 13.6055 0.400281 13.3735C0.266311 13.1414 0.266313 12.8555 0.400286 12.6235L7.34979 0.623464C7.48386 0.391797 7.73124 0.249146 7.99891 0.249146C8.26658 0.249146 8.51396 0.391797 8.64804 0.623464L15.5975 12.6235C15.7314 12.8554 15.7315 13.1411 15.5977 13.3731C15.4639 13.6051 15.2166 13.7482 14.9488 13.7485H14.9495ZM7.25004 9.99846V11.4985H7.94979H7.99854H8.04729H8.74854V9.99846H7.25004ZM7.25004 4.74846V8.49846H8.75004V4.74846H7.25004Z"
        fill="#C44A51"
      />
    </svg>
  );
};

export default DangeSignSvg;
